<template>
	<div class="layout">
		<div class="list-base">
			<div class="list-base-left">
				<Tag color='magenta' size='large' v-show="documentItem.checkState == 1">已创建</Tag>
				<Tag color='red' size='large' v-show="documentItem.checkState == 2">已过账</Tag>
				<Tag color='success' size='large' v-show="documentItem.checkState == 3">已完结</Tag>
				<span class="list-base-left-span">付款单：{{documentItem.code}}</span>
			</div>
			<div class="list-base-right">
				<span class="list-base-right-span">
					业务员：
					<span class="span-back-color">{{documentItem.userName}}</span>
				</span>
				<span class="list-base-right-span">
					业务日期：
					<span class="span-back-color">{{documentItem.businessDate}}</span>
				</span>
			</div>
		</div>
		<div class='list-module'>
			<div class="div-title">
				<div class="div-title-label">
					基础信息
				</div>
			</div>
			<Row class="div-content-row">
			    <Col span="8">单据编号：{{documentItem.code}}</Col>
			    <Col span="8">业务日期：{{documentItem.businessDate}}</Col>
			    <Col span="8">业务员：{{documentItem.userName}}</Col>
			</Row>
			<Row class="div-content-row">
			    <Col span="8">收款人：{{documentItem.payee}}</Col>
			    <Col span="8">备注：{{documentItem.note}}</Col>
			</Row>
		</div>
		<div class="list-module">
			<div class="div-title">
				<div class="div-title-label">
					单据信息
				</div>
			</div>
			<Table :columns="tableColumns" :data="documentItem.paymentDetailLists"></Table>
		</div>
		<div class="list-module">
			<div class="div-title">
				<div class="div-title-label">
					附件信息
				</div>
			</div>
			<DocumentFile :fileList='documentItem.fileList' :isShow='true'></DocumentFile>
		</div>
	</div>
</template>

<script>
	import request from '@/utils/request'
	import DocumentFile from '@/components/DocumentFile'
	export default {
		name: 'paymentplanlistdetail',
		components: {
			DocumentFile
		},
		data() {
			return {
				documentItem: {
                    id: 0,
                    code: '',
                    businessDate: '',
                    amount: 0,
                    discount: 100,
                    paymentDetailLists: [],
                    payee: '',
                    userId: '',
                    userName: '',
                    creator: parseInt(localStorage.getItem("userId")),
                    note: '',
                    payWay: '',
                    checkState: 1,//未过账
                    fileList:[]
				},
				tableColumns: [
                    {
                        title: '单据类型',
                        key: 'type',
                        width: 150
                    },
                    {
                        title: '单据编号',
                        key: 'listCode',
                        render: (h,params) => {
							return [h('a', {
								class:'jxyd-a',
							    on: {
							        click: (val) => {
										if (params.row.type == '采购单') {
											this.$router.push({
												path: 'purchaselistdetail',
												query: {
													purchaseListCode: params.row.listCode
												}
											});
										} else if (params.row.type == '销售退货单') {
											this.$router.push({
												path: 'returnsaleslistdetail',
												query: {
													returnSalesListCode: params.row.listCode
												}
											});
										} else if (params.row.type == '其它付款单') {
											this.$router.push({
												path: 'othercostlistdetail',
												query: {
													otherCostListCode: params.row.listCode
												}
											});
										}
							        }
							    }
							}, params.row.listCode)];
                        }
                    },
                    {
                        title: '单据日期',
                        key: 'businessDate',
                    },
                    {
                        title: '单据金额',
                        key: 'listAmount',
                    },
                    {
                        title: '已核销金额',
                        key: 'amountPaid',
                    },
                    {
                        title: '未核销金额',
                        key: 'amountUnpaid',
                    }],
				paymentDetail:[]
			}
		},

		methods: {
			getPaymentList(paymentListId) {
				let self = this;
				request.get('/api/PaymentList/GetPaymentList', {
					params: {
						id: paymentListId
					}
				}).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: response.errorMsg
						});
						return;
					}
					self.documentItem = response.data;
				}).catch(function(error) {})
			},
			getPaymentListByCode(paymentListCode) {
				let self = this;
				request.get('/api/PaymentList/GetPaymentListByCode', {
					params: {
						code: paymentListCode
					}
				}).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: response.errorMsg
						});
						return;
					}
					self.documentItem = response.data;
				}).catch(function(error) {})
			}
		},
		watch: {
			'$route.query.paymentListId':{
				immediate: true,
				handler(param) {
					if(param){
						this.getPaymentList(param);
					}
				}
			},
			'$route.query.paymentListCode':{
				immediate: true,
				handler(param) {
					if(param){
						this.getPaymentListByCode(param);
					}
				}
			}
		},
		created: function() {
		}
	}
</script>

<style scoped>
	.layout {
		border-radius: 8px;
	}
	
	.list-base{
		background-color: white;
		padding: 15px;
		overflow: hidden;
	}
	
	.list-base-left{
		float: left;
		display: flex;
		color: #000;
		justify-content: center; /* 水平居中 */
		align-items: center;    /* 垂直居中 */
		height: 100%;           /* 父元素需要固定高度或其它百分比高度 */
	}
	
	.list-base-left-span{
		font-size: 18px;
	}
	
	.list-base-right{
		display: flex;
		float: right;
		justify-content: center; /* 水平居中 */
		align-items: center;    /* 垂直居中 */
		height: 36px;     
	}
	
	.list-base-right-span{
		margin-left: 10px;
	}
	
	.span-back-color{
		color: #000;
	}
	
	.div-title {
		border-bottom: 1px solid #ebeef5;
		margin-bottom: 20px;
	}
	
	.div-title-label {
		border-left: 2px solid rgb(255, 106, 127);
		text-indent: 0.5em;
		font-weight: bold;
	}
	
	.list-module{
		background-color: white;
		margin-top: 20px;
		padding: 15px;
	}
	
	.div-content-row div{
		padding: 15px;
	}
	
	.div-content-row-center div{
		padding: 15px;
		text-align: center;
		font-size: 16px;
		color: #000;
		font-weight: bold;
	}
	
	.amount-color{
		color: rgb(255, 106, 127);
	}
	
	.div-content-detail{
		margin: 15px;
		background-color:#f8f8f9;
		padding: 20px;
	}
	
	.div-content-detail-title{
		text-indent: 0.5em;
		font-weight: bold;
		border-bottom: 1px solid #ebeef5;
	}
	.div-content-detail-list{
		margin-top: 10px;
	}
	.div-content-detail-list-title{
		text-indent: 0.5em;
	}
	
	.div-content-detail-list-content{
		overflow: hidden;
	}
	
	.div-content-detail-list-content-item{
		float: left;
		width: 30%;
		padding: 10px;
		text-align: center;
	}
	
	.extraCostShowTable {
	    margin-top: 10px;
		color: #000;
	}
	
	    .extraCostShowTable td {
	        padding: 5px;
	    }
	
</style>